<template>
    <div>
        <v-row no-gutters>
            <v-col class="d-flex">
                <v-tabs v-model="year">
                    <v-tab
                        value="0"
                        href="#0"
                        style="justify-content: left"
                        v-if="charge.isLineReported"
                    >
                        Exercice N-1
                    </v-tab>
                    <v-tab value="1" href="#1" style="justify-content: left"> Exercice N </v-tab>
                    <v-tab
                        value="2"
                        href="#2"
                        style="justify-content: left"
                        v-if="parameters.periodsNumber > 1"
                    >
                        Exercice N+1
                    </v-tab>
                    <v-tab
                        value="3"
                        href="#3"
                        style="justify-content: left"
                        v-if="parameters.periodsNumber > 2"
                    >
                        Exercice N+2
                    </v-tab>
                    <v-tab
                        value="4"
                        href="#4"
                        style="justify-content: left"
                        v-if="parameters.periodsNumber > 3"
                    >
                        Exercice N+3
                    </v-tab>
                    <v-tab
                        value="5"
                        href="#5"
                        style="justify-content: left"
                        v-if="parameters.periodsNumber > 4"
                    >
                        Exercice N+4
                    </v-tab>
                </v-tabs>
                <div class="d-flex align-center justify-center">
                    <v-icon @click="displayReinitializationDialog = true">$refresh</v-icon>
                </div>
            </v-col>
            <!-- <v-col>
                <v-icon @click="displayReinitializationDialog = true" location="end">$refresh</v-icon>
            </v-col> -->
        </v-row>

        <v-tabs-window v-model="year">
            <v-window-item value="0" v-if="charge.isLineReported">
                <v-data-table
                    :items="charge.detailsNM1[0]"
                    :headers="detailsHeaders"
                    :itemsPerPage="charge.detailsNM1[0].length"
                    hide-default-footer
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                {{ props.item.title }}
                            </td>
                            <td
                                v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                                :key="props.item.months[month].date"
                                class="pl-0 pr-1 py-0 ma-0"
                            >
                                <oss-text-field-filled
                                    hide-details
                                    disabled
                                    :model-value="props.item.months[month].amount"
                                />
                            </td>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                <oss-text-field-filled
                                    hide-details
                                    disabled
                                    v-model="props.item.total"
                                />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-window-item>
            <v-window-item value="1">
                <v-data-table
                    :items="detailsItems[0]"
                    :headers="detailsHeaders"
                    :itemsPerPage="detailsItems[0].length"
                    hide-default-footer
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                {{ props.item.title }}
                            </td>
                            <td
                                v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                                :key="props.item.months[month].date"
                                class="pl-0 pr-1 py-0 ma-0"
                            >
                                <oss-text-field-filled
                                    v-model="props.item.months[month].amount"
                                    hide-details="auto"
                                    :min="0"
                                    :disabled="
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    "
                                    @change="recomputeWhenChange([], props.index, month)"
                                    :data-cy="'test'"
                                />
                                <!-- test -->
                            </td>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="props.index === 1"
                                    v-model="props.item.total"
                                />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-window-item>
            <v-window-item value="2">
                <v-data-table
                    :items="detailsItems[1]"
                    :headers="detailsHeaders"
                    :itemsPerPage="detailsItems[1].length"
                    hide-default-footer
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                {{ props.item.title }}
                            </td>
                            <td
                                v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                                :key="props.item.months[month].date"
                                class="pl-0 pr-1 py-0 ma-0"
                            >
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    "
                                    @change="recomputeWhenChange([], props.index, month)"
                                    v-model="props.item.months[month].amount"
                                />
                            </td>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="props.index === 1"
                                    v-model="props.item.total"
                                />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-window-item>
            <v-window-item value="3">
                <v-data-table
                    :items="detailsItems[2]"
                    :headers="detailsHeaders"
                    :itemsPerPage="detailsItems[2].length"
                    hide-default-footer
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                {{ props.item.title }}
                            </td>
                            <td
                                v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                                :key="props.item.months[month].date"
                                class="pl-0 pr-1 py-0 ma-0"
                            >
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    "
                                    @change="recomputeWhenChange([], props.index, month)"
                                    v-model="props.item.months[month].amount"
                                />
                            </td>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="props.index === 1"
                                    v-model="props.item.total"
                                />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-window-item>
            <v-window-item value="4">
                <v-data-table
                    :items="detailsItems[3]"
                    :headers="detailsHeaders"
                    :itemsPerPage="detailsItems[3].length"
                    hide-default-footer
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                {{ props.item.title }}
                            </td>
                            <td
                                v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                                :key="props.item.months[month].date"
                                class="pl-0 pr-1 py-0 ma-0"
                            >
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    "
                                    @change="recomputeWhenChange([], props.index, month)"
                                    v-model="props.item.months[month].amount"
                                />
                            </td>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="props.index === 1"
                                    v-model="props.item.total"
                                />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-window-item>
            <v-window-item value="5">
                <v-data-table
                    :items="detailsItems[4]"
                    :headers="detailsHeaders"
                    :itemsPerPage="detailsItems[4].length"
                    hide-default-footer
                    class="table"
                >
                    <template v-slot:item="props">
                        <tr>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                {{ props.item.title }}
                            </td>
                            <td
                                v-for="month of [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]"
                                :key="props.item.months[month].date"
                                class="pl-0 pr-1 py-0 ma-0"
                            >
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="
                                        !props.item.editable ||
                                        (props.item.uneditedCount <= 1 &&
                                            !props.item.months[month].edited)
                                    "
                                    @change="recomputeWhenChange([], props.index, month)"
                                    v-model="props.item.months[month].amount"
                                />
                            </td>
                            <td class="pl-0 pr-1 py-0 ma-0">
                                <oss-text-field-filled
                                    hide-details
                                    :disabled="props.index === 1"
                                    v-model="props.item.total"
                                />
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-window-item>
        </v-tabs-window>
        <br />
        <br />
        <oss-dialog
            v-model="displayReinitializationDialog"
            height="25%"
            title="Réinitialisation des détails"
            width="45vw"
        >
            <v-card>
                <v-card-text class="py-0">
                    <v-list subheader lines="two">
                        <v-list-item
                            class="oss-list-item mb-2 rounded-lg"
                            @click="reinitializeYear"
                        >
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Réinitialiser uniquement l'exercice sélectionné</v-list-item-title
                            ></v-list-item
                        >
                        <v-list-item class="oss-list-item mb-2 rounded-lg" @click="reinitializeAll">
                            <template v-slot:append>
                                <v-btn-next />
                            </template>
                            <v-list-item-title
                                >Réinitialiser tous les exercices</v-list-item-title
                            ></v-list-item
                        >
                    </v-list>
                </v-card-text>
            </v-card>
        </oss-dialog>
    </div>
</template>

<script lang="ts">
import moment from "moment-timezone";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop, Emit } from "vue-facing-decorator";
// import ConsistencyChecksManager from "../../../../backend/src/common/bundle/consistencyChecks/ConsistencyChecksManager";

@Component
export class ChargeDetails extends Vue {
    // PROPS

    @Prop({ default: null }) charge: any;
    @Prop({ default: null }) parameters: any;
    // @Prop({ default: null }) study: any;
    @Prop({ default: true }) isDetailEditable: boolean;
    @Prop({ default: moment().startOf("month").format() }) date: string;

    // ATTRIBUTES

    year: string = "1";
    displayReinitializationDialog: boolean = false;

    // ITEMS & HEADERS

    get detailsHeaders() {
        const detailsHeaders = [
            { title: "Titre", value: "" },
            { title: "Totaux", value: "" },
        ];
        const year = parseInt(this.year);
        const index = year === 0 ? 0 : year - 1;
        let monthList = this.orderedMonthsPeriods[index]; // use v-tab attribute year to get the current period
        if (year === 0) {
            monthList = this.reduceYearExercise(monthList);
        }
        for (let monthIndex = 0; monthIndex < monthList.length; monthIndex++) {
            // insertion of each month in headers list at index monthIndex+1 to be between the 2 existing columns
            const headerLine = { title: monthList[monthIndex], value: "" };
            detailsHeaders.splice(monthIndex + 1, 0, headerLine);
        }
        return detailsHeaders;
    }

    reduceYearExercise(dateList) {
        const newDateList = [];
        for (const date of dateList) {
            const mDate = moment(date, "MMMM YYYY");
            const newDate = mDate.subtract(12, "months").format("MMMM YYYY");
            newDateList.push(newDate);
        }
        return newDateList;
    }

    // DATA STORAGE

    // buildYearlyDetailsItems(key) {
    //     // building of data structure in the details data-table
    //     if(key+1 > this.charge.years.length) {
    //         return [];
    //     }
    //     let detailsItems = [];
    //     const monthList = this.orderedMonthsPeriods[key];
    //     let monthsNumber = monthList.length;
    //     let totalAmount = this.charge.years[key].amount;
    //     let splittedAmount = totalAmount / monthsNumber;
    //     let months = [];
    //     for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
    //         const month = {
    //             amount: splittedAmount.toFixed(0),
    //             date: monthList[monthIndex],
    //             edited: false,
    //             manuallyModified: false
    //         };
    //         months.push(month)
    //     }
    //     let soldPrestations = {
    //         title: "Prestations vendues",
    //         total: totalAmount,
    //         months: months,
    //         uneditedCount: months.length,
    //         editable: true
    //     };
    //     detailsItems.push(soldPrestations);
    //     let monthsSaisonnality = []
    //     for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
    //         const month = {
    //             amount: (months[monthIndex].amount/totalAmount*100).toFixed(2),
    //             date: monthList[monthIndex],
    //             edited: false,
    //             manuallyModified: false
    //         };
    //         monthsSaisonnality.push(month);
    //     }
    //     let saisonnality = {
    //         title: "Saisonnalité",
    //         total: 100,
    //         months: monthsSaisonnality,
    //         uneditedCount: months.length,
    //         editable: true

    //     };
    //     detailsItems.push(saisonnality);

    //     return detailsItems;
    // }

    buildYearlyDetailsItems(key, previousDetails) {
        // build or rebuild data structure every time the budget is loaded or a yearly total is modified
        if (key + 1 > this.charge.years.length) {
            // years not used
            return [];
        }
        let yearlyDetailsItems = this.buildYearlyDetailsItemsFromScratch(key);
        if (!previousDetails || previousDetails.length === 0) {
            // first building at the creation of the budget, TO PUT IN CP ?
            return yearlyDetailsItems;
        }
        let oneEditedMonthIndex = -1; // counter keeping track of an edited month, used to update unmodified columns at the end (trick)
        for (let monthIndex = 0; monthIndex < previousDetails[0].months.length; monthIndex++) {
            // we could have taken yearlyDetailsItems to reference the indexes instead of previousDetails
            if (previousDetails[0].months[monthIndex].edited) {
                if (oneEditedMonthIndex < 0) {
                    oneEditedMonthIndex = monthIndex;
                }
                if (previousDetails[0].months[monthIndex].manuallyModified) {
                    // value to keep is the amount, computing the new saisonnalities, but not updating the other columns yet to reduce computation time
                    yearlyDetailsItems[0].uneditedCount -= 1;
                    yearlyDetailsItems[0].months[monthIndex].edited = true;
                    yearlyDetailsItems[0].months[monthIndex].manuallyModified = true;
                    yearlyDetailsItems[0].months[monthIndex].amount =
                        previousDetails[0].months[monthIndex].amount;
                    yearlyDetailsItems[1].uneditedCount -= 1;
                    yearlyDetailsItems[1].months[monthIndex].edited = true;
                    yearlyDetailsItems[1].months[monthIndex].amount = (
                        (100 * yearlyDetailsItems[0].months[monthIndex].amount) /
                        yearlyDetailsItems[0].total
                    ).toFixed(2);
                } else if (previousDetails[1].months[monthIndex].manuallyModified) {
                    // value to keep is the saisonnality, computing the new amounts, but not updating the other columns yet to reduce computation time
                    yearlyDetailsItems[1].uneditedCount -= 1;
                    yearlyDetailsItems[1].months[monthIndex].edited = true;
                    yearlyDetailsItems[1].months[monthIndex].manuallyModified = true;
                    yearlyDetailsItems[1].months[monthIndex].amount =
                        previousDetails[1].months[monthIndex].amount;
                    yearlyDetailsItems[0].uneditedCount -= 1;
                    yearlyDetailsItems[0].months[monthIndex].edited = true;
                    yearlyDetailsItems[0].months[monthIndex].amount = (
                        (yearlyDetailsItems[0].total *
                            yearlyDetailsItems[1].months[monthIndex].amount) /
                        100
                    ).toFixed(0);
                }
            }
        }
        if (oneEditedMonthIndex >= 0) {
            this.recomputeWhenChange(yearlyDetailsItems, 0, oneEditedMonthIndex); // updating the unedited columns
        }
        return yearlyDetailsItems;
    }

    buildYearlyDetailsItemsFromScratch(key) {
        // construction of the details at the creation of a budget, if there is no previous values
        let yearlyDetailsItems = [];
        const monthList = this.orderedMonthsPeriods[key];
        let monthsNumber = monthList.length;
        let totalAmount = this.charge.years[key].amount;
        let splittedAmount = totalAmount / monthsNumber;
        let months = [];
        for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
            const month = {
                amount: splittedAmount.toFixed(0),
                date: monthList[monthIndex],
                edited: false,
                manuallyModified: false,
            };
            months.push(month);
        }
        let soldPrestations = {
            title: "Montant à payer",
            total: totalAmount,
            months: months,
            uneditedCount: months.length,
            editable: this.isDetailEditable,
        };
        yearlyDetailsItems.push(soldPrestations);
        let monthsSaisonnality = [];
        for (let monthIndex = 0; monthIndex < monthsNumber; monthIndex++) {
            const amount = totalAmount === 0 ? 0 : (months[monthIndex].amount / totalAmount) * 100;
            const month = {
                amount: amount.toFixed(2),
                date: monthList[monthIndex],
                edited: false,
                manuallyModified: false,
            };
            monthsSaisonnality.push(month);
        }
        let saisonnality = {
            title: "Saisonnalité",
            total: 100,
            months: monthsSaisonnality,
            uneditedCount: months.length,
            editable: this.isDetailEditable,
        };
        yearlyDetailsItems.push(saisonnality);
        return yearlyDetailsItems;
    }

    get detailsItems() {
        // copying current the values of detailsItems needed to rebuild detailsItems without loss
        const previousDetails = JSON.parse(JSON.stringify(this.charge.details));
        this.charge.details = [
            this.buildYearlyDetailsItems(0, previousDetails[0]),
            this.buildYearlyDetailsItems(1, previousDetails[1]),
            this.buildYearlyDetailsItems(2, previousDetails[2]),
            this.buildYearlyDetailsItems(3, previousDetails[3]),
            this.buildYearlyDetailsItems(4, previousDetails[4]),
        ];
        return this.charge.details;
        // return [
        //     this.charge.details[0] ? this.charge.details[0] : this.buildDetailsItems(0),
        //     this.charge.details[1] ? this.charge.details[1] : this.buildDetailsItems(1),
        //     this.charge.details[2] ? this.charge.details[2] : this.buildDetailsItems(2),
        //     this.charge.details[3] ? this.charge.details[3] : this.buildDetailsItems(3),
        //     this.charge.details[4] ? this.charge.details[4] : this.buildDetailsItems(4)
        // ]
    }

    set detailsItems(value) {
        this.charge.details = value;
    }

    // GETTERS & SETTERS

    get orderedMonthsFirstPeriod() {
        let orderedMonthsFirstPeriod = [];
        let currentMonth = moment(this.date).format("MMMM YYYY");
        orderedMonthsFirstPeriod.unshift(currentMonth);
        for (let month = 1; month < this.parameters.firstPeriodMonthsNumber; month++) {
            currentMonth = moment(currentMonth, "MMMM YYYY").add(1, "months").format("MMMM YYYY");
            orderedMonthsFirstPeriod.push(currentMonth);
        }
        return orderedMonthsFirstPeriod;
    }

    get orderedMonthsPeriods() {
        // creation of the month list of each accountingPeriod
        let orderedMonthsPeriods = [];
        orderedMonthsPeriods.unshift(this.orderedMonthsFirstPeriod); // creation of the first period is different because it may contains more than 12 months
        for (let year = 1; year < this.parameters.periodsNumber; year++) {
            let orderedMonthsCurrentPeriod = [];
            const previousYearLastMonthIndex =
                year === 1 ? this.parameters.firstPeriodMonthsNumber - 1 : 11;
            let currentMonth = moment(
                orderedMonthsPeriods[year - 1][previousYearLastMonthIndex],
                "MMMM YYYY",
            )
                .add(1, "months")
                .format("MMMM YYYY"); // get the first month of the current period
            orderedMonthsCurrentPeriod.unshift(currentMonth);
            for (let month = 1; month < this.parameters.firstPeriodMonthsNumber; month++) {
                currentMonth = moment(currentMonth, "MMMM YYYY")
                    .add(1, "months")
                    .format("MMMM YYYY");
                orderedMonthsCurrentPeriod.push(currentMonth);
            }
            orderedMonthsPeriods.push(orderedMonthsCurrentPeriod);
        }
        return orderedMonthsPeriods;
    }

    // DECORATORS

    // METHODS

    // recomputeWhenChange(detailsArg, detailsLineIndex, amountChangedIndex) {
    //     // update the line of the current change while modifying the unedited amounts
    //     let amountToKeep = item.months[amountChangedIndex].amount;
    //     if (!item.months[amountChangedIndex].edited) {
    //         item.uneditedCount -= 1;
    //         item.months[amountChangedIndex].edited = true;
    //     }
    //     const subTotal = item.total - amountToKeep; // subTotal to divise between the unedited left months
    //     for (let month of item.months) {
    //         if (!month.edited) {
    //             month.amount = (subTotal / item.uneditedCount).toFixed(2);
    //         }
    //     }
    //     if (item.title === "Saisonnalité") {
    //         this.recomputeAmountsWhenSaisonnalityChange(amountChangedIndex, amountToKeep);
    //     }
    //     else if (item.title === "Prestations vendues") {
    //         this.recomputeSaisonnalityWhenAmountsChange(amountChangedIndex, amountToKeep, item.total);
    //     }
    // }

    // recomputeAmountsWhenSaisonnalityChange(amountChangedIndex, percentageChanged) {
    //     let amountsLine = this.detailsItems[parseInt(this.year)-1][0];
    //     amountsLine.months[amountChangedIndex].amount = (amountsLine.total * percentageChanged / 100).toFixed(0);
    //     if (!amountsLine.months[amountChangedIndex].edited) {
    //         amountsLine.uneditedCount -= 1;
    //         amountsLine.months[amountChangedIndex].edited = true;
    //     }
    //     const splittedAmount = (this.computeSubTotal(amountsLine) / amountsLine.uneditedCount).toFixed(0);
    //     for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
    //         if(!amountsLine.months[monthIndex].edited) {
    //             amountsLine.months[monthIndex].amount = splittedAmount;
    //         }
    //     }
    //     this.saveDetailsCharge();
    // }

    // recomputeSaisonnalityWhenAmountsChange(amountChangedIndex, amountChanged, total) {
    //     let amountsLine = this.detailsItems[parseInt(this.year)-1][1];
    //     amountsLine.months[amountChangedIndex].amount = (100 * amountChanged / total).toFixed(1);
    //     if (!amountsLine.months[amountChangedIndex].edited) {
    //         amountsLine.uneditedCount -= 1;
    //         amountsLine.months[amountChangedIndex].edited = true;
    //     }
    //     const splittedAmount = (this.computeSubTotal(amountsLine) / amountsLine.uneditedCount).toFixed(1);
    //     for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
    //         if(!amountsLine.months[monthIndex].edited) {
    //             amountsLine.months[monthIndex].amount = splittedAmount;
    //         }
    //     }
    //     this.saveDetailsCharge();
    // }

    // computeSubTotal(amountsLine) {
    //     // given a line, compute the total amount to be splitted between the unedited lines
    //     let subTotal = amountsLine.total;
    //     for (const month of amountsLine.months) {
    //         if (month.edited) {
    //             subTotal -= month.amount;
    //         }
    //     }
    //     return subTotal
    // }

    @Emit("store-active-details")
    storeActiveDetails(pathToActive) {
        return pathToActive;
    }

    recomputeWhenChange(detailsArg, detailsLineIndex, amountChangedIndex) {
        // update the line of the current change while modifying the unedited amounts
        let details = detailsArg; // checking if existing details instead of recomputing a blank one from scratch
        if (details.length === 0) {
            details = this.detailsItems[parseInt(this.year) - 1];
        }
        let detailsLine = details[detailsLineIndex];
        let amountToKeep = detailsLine.months[amountChangedIndex].amount;
        if (!detailsLine.months[amountChangedIndex].edited) {
            detailsLine.uneditedCount -= 1;
            detailsLine.months[amountChangedIndex].edited = true;
            detailsLine.months[amountChangedIndex].manuallyModified = true;
        }
        const subTotal = this.computeSubTotal(detailsLine); // subTotal to divise between the unedited left months
        for (let month of detailsLine.months) {
            if (!month.edited) {
                month.amount = (subTotal / detailsLine.uneditedCount).toFixed(2);
            }
        }
        if (detailsLine.title === "Saisonnalité") {
            let amountsLine = details[0];
            this.recomputeAmountsWhenSaisonnalityChange(
                amountsLine,
                amountChangedIndex,
                amountToKeep,
            );
        } else if (detailsLine.title === "Montant à payer") {
            let percentagesLine = details[1];
            this.recomputeSaisonnalityWhenAmountsChange(
                percentagesLine,
                amountChangedIndex,
                amountToKeep,
                detailsLine.total,
            );
            const pathToActive = {
                item: this.charge,
                itemType: "charge",
                yearIndex: parseInt(this.year) - 1,
                monthIndex: amountChangedIndex,
                valueToReport: amountToKeep,
            };
            this.storeActiveDetails(pathToActive);
        }
    }

    recomputeAmountsWhenSaisonnalityChange(amountsLine, amountChangedIndex, percentageChanged) {
        amountsLine.months[amountChangedIndex].amount = (
            (amountsLine.total * percentageChanged) /
            100
        ).toFixed(0);
        if (!amountsLine.months[amountChangedIndex].edited) {
            amountsLine.uneditedCount -= 1;
            amountsLine.months[amountChangedIndex].edited = true;
        }
        const splittedAmount = (
            this.computeSubTotal(amountsLine) / amountsLine.uneditedCount
        ).toFixed(0);
        for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
            if (!amountsLine.months[monthIndex].edited) {
                amountsLine.months[monthIndex].amount = splittedAmount;
            }
        }
    }

    recomputeSaisonnalityWhenAmountsChange(
        percentagesLine,
        amountChangedIndex,
        amountChanged,
        total,
    ) {
        percentagesLine.months[amountChangedIndex].amount = ((100 * amountChanged) / total).toFixed(
            2,
        );
        if (!percentagesLine.months[amountChangedIndex].edited) {
            percentagesLine.uneditedCount -= 1;
            percentagesLine.months[amountChangedIndex].edited = true;
        }
        const splittedAmount = (
            this.computeSubTotal(percentagesLine) / percentagesLine.uneditedCount
        ).toFixed(2);
        for (let monthIndex = 0; monthIndex < 12; monthIndex++) {
            if (!percentagesLine.months[monthIndex].edited) {
                percentagesLine.months[monthIndex].amount = splittedAmount;
            }
        }
    }

    computeSubTotal(detailsLine) {
        // given a line, compute the total amount to be splitted between the unedited lines
        let subTotal = detailsLine.total;
        for (const month of detailsLine.months) {
            if (month.edited) {
                subTotal -= month.amount;
            }
        }
        return subTotal;
    }

    // get detailsRules() {
    //     const rules = [];
    //     rules.push(v => parseFloat(v) >= 0 || "Le montant est négatif");
    //     return rules;
    // }

    // computeDetailsSum(item) {
    //     let sum = this.charge.years[parseInt(this.year)-1].amount;
    //     for (const month of this.detailsItems[parseInt(this.year)-1][0].months) {
    //         sum -= month.amount;
    //     }
    //     if (sum < -10) {
    //         return item.edited ? "La somme dépasse le montant annuel" : true;
    //     } else {
    //         return true;
    //     }
    // }

    // getEditedSum(detailLine) {
    //     let sum = 0;
    //     for (const month of detailLine.months) {
    //         if (month.edited) {
    //             sum += parseFloat(month.amount);
    //         }
    //     }
    //     return sum;
    // }

    // checkUserInput(newValue, detailLine, monthIndex) {
    //     const round = 12; // to avoid round errors
    //     let limit = newValue + this.getEditedSum(detailLine);
    //     if (detailLine.months[monthIndex].edited) {
    //         limit -= parseFloat(detailLine.months[monthIndex].amount);
    //     }
    //     if (limit < detailLine.total + round) {
    //         detailLine.months[monthIndex].amount = newValue;
    //     } else {
    //         // this.detailsItems[parseInt(this.year)-1][0].months[monthIndex].amount = parseFloat(detailLine.months[monthIndex].amount);
    //     }
    // }

    // get validForm() {
    //     for (const yearlyDetail of this.detailsItems) {
    //         for (const line of yearlyDetail) {
    //             for (const month of line.months) {
    //                 if (month.amount < 0) {
    //                     return false;
    //                 }
    //             }
    //         }
    //     }
    //     return true;
    // }

    reinitializeYear() {
        const year = parseInt(this.year) - 1;
        this.detailsItems[year] = this.buildYearlyDetailsItems(year, undefined);
        this.$forceUpdate();
        this.displayReinitializationDialog = false;
    }

    reinitializeAll() {
        for (const yearStr in this.charge.years) {
            const year = parseInt(yearStr);
            this.detailsItems[year] = this.buildYearlyDetailsItems(year, undefined);
        }
        this.$forceUpdate();
        this.displayReinitializationDialog = false;
    }
}

export default toNative(ChargeDetails);
</script>

<style></style>
